import appConfig from 'appConfig';
import Cookies from 'js-cookie';
export default {
  name: 'queryPanel',
  data() {
    return {
      accessToken: { accessToken: Cookies.get('accessToken') }, // 上传token鉴权
      layersData: [],
      formItems: [
        {
          fild: '',
          value: '',
          operator: '',
          logic: '',
          valuesList: [],
          index: 0,
        },
      ],
      layerFields: [], //属性列表
      gridDrawLayer: null,
      bufferDrawLayer: new this.$olmap.layer.Vector({
        id: '__buffer',
        zIndex: 1004,
        source: new this.$olmap.source.Vector(),
        style: new this.$olmap.style.Style({
          //图层样式
          fill: new this.$olmap.style.Fill({
            color: 'rgba(255, 255, 255, 0.5)', //填充颜色
          }),
          stroke: new this.$olmap.style.Stroke({
            color: '#FFFF00', //边框颜色
            width: 2, // 边框宽度
          }),
        }),
      }),
      gridDraws: null,
      drawGrid: {
        geometry: '',
        polygonWKT: '',
        polygonJson: [],
        feature: null,
      },
      currentGeometryType: 'POLYGON',
      currentDrawType: '',
      isDrawBuffer: false,
      xbootConfig: '',
      xbootshpConfig: '',
      configMap: {},
      jsonBuffer: {}, //接口返回的json数据
      layerQueryData: {},
      proviceDataList: [], //行政区划的数据
      selectAreaArr: [],
      fileId: '',
      shpGeometryWkt: '',
      shpGeojsonStr: '',
    };
  },
  components: {},
  computed: {},
  props: {},
  watch: {},
  mounted() {
    this.olmap.addLayer(this.bufferDrawLayer);
  },
  created() {
    this.xbootConfig = this.publicMethod.xbootConfig;
    this.xbootshpConfig = this.publicMethod.baseXbootShp;
    this.configMap = appConfig.map;
  },
  methods: {
    /*绘制点线面 */
    drawArea(type) {
      if (type == 'delete' && this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDrawLayer.getSource().clear();
        this.bufferDrawLayer.getSource().clear();
        this.publicMethod.deletdwglayer(this.olmap);
        this.isDrawBuffer = false;
        this.$bus.emit("drawPolygon" , '')
        return;
      }
      switch (type) {
        case 'Circle':
        case 'Box':
        case 'Polygon':
          this.currentGeometryType = 'POLYGON';
          break;
        case 'LineString':
          this.currentGeometryType = 'LINESTRING';
          break;
        case 'Point':
          this.currentGeometryType = 'POINT';
          break;
      }
      this.currentDrawType = type;
      this.initDraw(type);
      this.olmap.addInteraction(this.gridDraws);
      let that = this;
      this.gridDraws.on('drawend', function (evt) {
        if (type == 'Circle') {
          that.drawGrid.geometry = that.$olmap.geom.Polygon.fromCircle(
            evt.feature.getGeometry(),
            64
          );
        } else {
          that.drawGrid.geometry = evt.feature.getGeometry();
        }
        that.drawGrid.polygonWKT = new that.$olmap.format.WKT().writeGeometry(
          that.drawGrid.geometry,
          {}
        );
        that.$bus.emit("drawPolygon" , that.drawGrid.polygonWKT)
        that.drawGrid.polygonJson = that.drawGrid.geometry.getCoordinates();
        that.olmap.removeInteraction(that.gridDraws);
      });
    },

    initDraw(type, datasource) {
      //实例化一个矢量图层Vector作为绘制层
      if (this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDrawLayer.getSource().clear();
        this.bufferDrawLayer.getSource().clear();
        this.isDrawBuffer = false;
      }
      var result = this.publicMethod.initDrawC(type, datasource); //通用封装方法
      this.gridDraws = result.gridDraws;
      this.gridDrawLayer = result.gridDrawLayer;
      this.olmap.addLayer(this.gridDrawLayer);
    },

    //初始化数据源
    initSource(features, geomtry, typeCode) {
      var datasource;
      if (features) {
        //根据上传shp绘制
        datasource = new this.$olmap.source.Vector({
          features: features,
        });
        this.olmap.getView().fit(datasource.getExtent());
      }
      if (geomtry) {
        //根据上传txt坐标点
        var featuresList = [];
        this.drawGrid.polygonJson = [];
        this.drawGrid.polygonWKT = [];
        for (var item in geomtry) {
          //上传txt存在多面
          var PolygonFeature = new this.$olmap.Feature({
            geometry: geomtry[item],
          });
          if (typeCode == 'bzb') {
            this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0][0]);
          } else {
            this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0]);
          }
          // this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0][0]);
          featuresList.push(PolygonFeature);
          this.drawGrid.polygonWKT.push(
            new this.$olmap.format.WKT().writeGeometry(PolygonFeature.getGeometry(), {})
          ); // geoserver方式
          if(this.drawGrid.polygonWKT.length > 0) {
            this.$bus.emit("drawPolygon" , this.drawGrid.polygonWKT[0])
          }
        }
        datasource = new this.$olmap.source.Vector({
          features: featuresList,
        });
        this.olmap.getView().fit(datasource.getExtent());
      }
      this.initDraw('Polygon', datasource);
    },
    //txt上传
    txtBeforupload(file) {
      if (file.type == 'text/plain') {
        var that = this;
        let reader = new FileReader();
        reader.readAsText(file);
        reader.onload = function (oFREvent) {
          //读取完毕从中取值
          var pointsTxt = oFREvent.target.result;
          if (pointsTxt) {
            let result = that.publicMethod.selectTextFile(pointsTxt); //通用txt封装方法
            if(!result){
              that.$Message.info("该数据格式不正确，不支持解析!")
              return;
            }
            result.currentGeometryType = that.currentGeometryType;
            if (result.inputPolygons && result.inputPolygons.length > 0) {
              that.initSource(null, result.inputPolygons, result.typeCode);
            } else {
              that.$Message.warning({
                content: 'txt的坐标文件不正确',
              });
            }
          } else {
            that.$Message.warning({
              content: 'txt的坐标文件不正确',
            });
          }
        };
      } else {
        this.$Message.info('请上传txt文件');
      }
      return false;
    },
    commonDataGrid(result, type) {
      this.drawGrid.polygonWKT = result.polygonWKT[0]; //去第一个json的数据
      this.$bus.emit("drawPolygon" , this.drawGrid.polygonWKT)
      this.drawGrid.geometry = result.geometry;
      this.drawGrid.polygonJson = result.polygonJson[0]; //shp文件第一个面的数据
      this.currentGeometryType = 'POLYGON';
      if (!type || type != 'dwg') {
        this.initSource(result.shpfeatures);
      }
    },
    //shp上传
    shpBeforupload(file) {
      if (file.name.indexOf('.shp') == -1) {
        this.$Message.info('请上传shp文件');
      } else {
        var that = this;
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = function () {
          let shapefile = require('shapefile');
          shapefile.read(this.result).then(geoJson => {
            var result = that.publicMethod.initJson(geoJson);
            that.commonDataGrid(result);
          });
        };
      }
    },
    handleSuccess(res, file) {
      if (res.success === true) {
        this.$Message.success("上传文件 " + file.name + " 成功");
        this.fileId = res.result.id;
        this.shpGeometryWkt = res.result.geometryWkt;
        this.shpGeojsonStr = res.result.geojsonStr;
      } else {
        this.$Message.warning(res.message);
      }
    },
    //重置
    handleReset() {
      this.$refs.form.resetFields();
      this.fileId = '';
      if (this.gridDraws) {
        this.gridDrawLayer.getSource().clear();
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDraws = null;
      }
      this.selectAreaArr = [];
      this.selectAreaForm = [];
      this.drawGrid = {
        geometry: '',
        polygonWKT: '',
        polygonJson: [],
        feature: null,
      };
      this.currentGeometryType = 'POLYGON';
      this.currentDrawType = '';
      this.bufferDrawLayer.getSource().clear();
      this.isDrawBuffer = false;
    },
  },
  befordestory() {
  },
};



// WEBPACK FOOTER //
// ./src/components/leftmenu/query/queryPanel.js